import { Dispatch, SetStateAction } from 'react';
import { AdmissionType, BottleService, GuestList, Ticket } from '@domain/admission';
import { Moment } from 'moment-timezone';

export const SALES_START_TYPE_NOW = 'now';
export const SALES_START_TYPE_CUSTOM_DATE = 'customDate';
export const SALES_START_TYPE_AFTER_OFFER = 'afterOffer';

export type SalesStartType =
  | typeof SALES_START_TYPE_NOW
  | typeof SALES_START_TYPE_CUSTOM_DATE
  | typeof SALES_START_TYPE_AFTER_OFFER;

export const SALES_END_TYPE_AT_EVENTS_START = 'atEventsStart';
export const SALES_END_TYPE_AT_EVENTS_END = 'atEventsEnd';
export const SALES_END_TYPE_CUSTOM_DATE = 'customDate';

export type SalesEndType =
  | typeof SALES_END_TYPE_AT_EVENTS_START
  | typeof SALES_END_TYPE_AT_EVENTS_END
  | typeof SALES_END_TYPE_CUSTOM_DATE;

export interface SalesWindowValue {
  startType: SalesStartType;
  startDate: Moment | null;
  startTime: string;
  endType: SalesEndType;
  endDate: Moment | null;
  endTime: string;
}

export interface SalesWindowContext {
  now: Moment;
  timezone: string;
  locale: string;
  eventId: string;
  eventStartingTime: number;
  eventEndingTime: number;
  maxEndDate: Moment;
  eventIsInThePast?: boolean;
  offerType: AdmissionType;
  offerId?: string;
  afterOfferDescription?: string;
  selectedOfferTrigger: BottleService | GuestList | Ticket | null;
  setSelectedOfferTrigger: Dispatch<SetStateAction<BottleService | GuestList | Ticket | null>>;
  onTriggerOfferCancel?: () => void;
}

export interface AdmissionSalesDatesErrors {
  salesStart?: string;
  salesEnd?: string;
  globalError?: string | null;
}

export const SALES_WINDOW_VARIANT_SELECT = 'select';
export const SALES_WINDOW_VARIANT_PLAIN = 'plain';

export type SalesWindowVariant = typeof SALES_WINDOW_VARIANT_SELECT | typeof SALES_WINDOW_VARIANT_PLAIN;

export interface AdmissionSalesDatesProps {
  value: SalesWindowValue;
  onChange: (next: Partial<SalesWindowValue>) => void;
  context: SalesWindowContext;
  errors?: AdmissionSalesDatesErrors;
  disabled?: boolean;
  variant?: SalesWindowVariant;
  dataTestId?: string;
}
